// :cow: Cosmose CONFIDENTIAL :iso:
import { Pipe, PipeTransform } from '@angular/core';
import { ClientsResponse } from '../../models/clients-response';

@Pipe({
  name: 'clientName',
})
export class ClientNamePipe implements PipeTransform {

  transform(value: number, clientsResponse: ClientsResponse): any {
    return this.nameOf(value, clientsResponse);
  }

  nameOf(clientId: number, clientsResponse: ClientsResponse): string {
    return clientsResponse
      ? this.getClient(clientId, clientsResponse)
      : clientId.toString();
  }

  private getClient(clientId: number, clientsResponse: ClientsResponse): string {
    const client = clientsResponse.content.find((element) => element.id.toString() === clientId.toString());
    return client ? client.name : clientId.toString();
  }

}
